import ProductCardView from './ProductCardView';

export default ProductCardView;
